import { GridColDef } from '@mui/x-data-grid';
import numberDecorator from 'src/decorators/number.decorator';
import { EstimationEntity } from 'src/entities/Estimation.entity';
import numberUtil from 'src/utils/number.util';

const costDistanceColumns: GridColDef[] = [
  {
    field: 'deliveryName',
    headerName: '勤務計画',
    type: 'string' as const,
  },
  {
    field: 'totalOrderOperationDistanceMm',
    headerName: '車庫帰着を除く合計距離',
    type: 'number' as const,
    valueGetter: (params: { row: EstimationEntity }) => numberUtil.convertFromMmToKm(params.row.totalOrderOperationDistanceMm),
    valueFormatter: (value: number) => numberDecorator.toRoundedKm(
      value,
      ''
    )
  },
  {
    field: 'totalDistanceMm',
    headerName: '合計距離',
    type: 'number' as const,
    valueGetter: (params: { row: EstimationEntity }) => numberUtil.convertFromMmToKm(params.row.totalOrderOperationDistanceMm + params.row.arrivalOperationDistanceMm),
    valueFormatter: (value: number) => numberDecorator.toRoundedKm(
      value,
      ''
    )
  },
  {
    field: 'expectedFeeYenByKm',
    headerName: '🖊️️1kmあたり運賃',
    type: 'number' as const,
    editable: true,
    valueFormatter: (value: number) => numberDecorator.toYen(
      value
    )
  },
  {
    field: 'feeExcludeArrivalOperation',
    headerName: '運賃（車庫帰着を除く）',
    type: 'number' as const,
    valueGetter: (params: { row: EstimationEntity }) => {
      if (!params.row.expectedFeeYenByKm) return undefined;

      const distanceMm = params.row.totalOrderOperationDistanceMm;

      return distanceMm * (params.row.expectedFeeYenByKm / 1000000);
    },
    valueFormatter: (value: number) => numberDecorator.toYen(
      value,
    ),
  },
  {
    field: 'fee',
    headerName: '運賃',
    type: 'number',
    valueGetter: (params: { row: EstimationEntity }) => {
      if (!params.row.expectedFeeYenByKm) return undefined;

      const distanceMm = params.row.totalOrderOperationDistanceMm + params.row.arrivalOperationDistanceMm;

      return distanceMm * (params.row.expectedFeeYenByKm / 1000000);
    },
    valueFormatter: (value: number) => numberDecorator.toYen(
      value,
    ),
  },
];

export default costDistanceColumns;
